import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { Link } from 'react-router-dom';
import formatDateToBR from '../../../utils/formatDateToBR';
import { newsText } from '../helpers/newsSeo';
import NewsImage from './NewsImage';


function NewsHomeMostRelevantComponent({ dataMostRelevantNews, isVisible, countNewsView }) {
    useEffect(() => {
        if (isVisible) {
            dataMostRelevantNews.forEach((news) => {
                countNewsView({
                    newsId: news.id,
                    timestamp: Date.now(),
                });
            });
        }
    }, [isVisible, countNewsView, dataMostRelevantNews]);


    return (
        <div className="tw-container tw-mx-auto">
            {dataMostRelevantNews.slice(0, 6).map((news, index) => {
                const link = `/noticias/${news.slug}`;

                return (
                    <div key={news.id}>
                        {index === 0 &&
                        <div className="box">
                            <Link
                                to={link}
                                className="tw-grid tw-grid-cols-1"
                                title={`Saiba mais sobre ${news.title}`}
                            >
                                <div>
                                    {index === 0 && (
                                        <NewsImage
                                            news={news}
                                            featured
                                            priority
                                            sizes="(min-width: 1280px) 560px, (min-width: 768px) 45vw, calc(100vw - 40px)"
                                            className="tw-mb-3"
                                        />
                                    )}

                                    <p className="alternativeFontSize tw-text-gray-500 data-publicacao">
                                        {formatDateToBR(news.date)}
                                    </p>

                                    <h3 className="tw-mb-3 title limitText2">
                                        {news.title}
                                    </h3>

                                    <p className="tw-my-3 tw-mb-0 limitText3">
                                        {newsText(news.content)}
                                    </p>
                                </div>
                            </Link>
                        </div>}
                    </div>
                );
            })}
        </div>
    );
}

NewsHomeMostRelevantComponent.propTypes = exact({
    dataMostRelevantNews: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
            date: PropTypes.string.isRequired,
            title: PropTypes.string.isRequired,
            slug: PropTypes.string.isRequired,
            imageNew: PropTypes.string,
            imageUrl: PropTypes.string,
            featuredImage: PropTypes.string,
            content: PropTypes.string,
        }),
    ).isRequired,
    // Still supplied by the shared home container; images now use native responsive sizing.
    // eslint-disable-next-line react/no-unused-prop-types
    breakpointReducer: PropTypes.object.isRequired,
    // isFeatured: PropTypes.bool,
    isVisible: PropTypes.bool,
    countNewsView: PropTypes.func.isRequired,
});

export default NewsHomeMostRelevantComponent;
